import axios from "axios";
import { EventSourcePolyfill } from "event-source-polyfill";

import { stringGetter } from "../common/utilities/localstorage-dealer/localstorage-getters.util";
import { isAuthDomain } from "../common/utilities/routes/routes.util";

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

const baseUrl: string = process.env.REACT_APP_API_ENDPOINT || "";

const APIHandler = axios.create({ baseURL: baseUrl });
const UnauthedAPIHandler = axios.create({ baseURL: baseUrl });
const EventSourceHandler = (url: string) => {
    const headers: Record<string, string> = {
        Authorization: `Bearer ${stringGetter(ACCESS_TOKEN_KEY)}`
    };

    // Add tenant origin header if on login domain
    const storedTenantOrigin = sessionStorage.getItem("auth_tenant_origin");

    if (isAuthDomain() && storedTenantOrigin) {
        headers["X-Tenant-Origin"] = storedTenantOrigin;
    }

    return new EventSourcePolyfill(`${baseUrl}${url}`, { headers });
};

// Helper to add tenant origin header when on login domain
const addTenantOriginHeader = (req: any) => {
    const storedTenantOrigin = sessionStorage.getItem("auth_tenant_origin");

    if (isAuthDomain() && storedTenantOrigin) {
        req.headers["X-Tenant-Origin"] = storedTenantOrigin;
    }
    return req;
};

APIHandler.interceptors.request.use(req => {
    if (stringGetter(ACCESS_TOKEN_KEY)) {
        req.headers.Authorization = `Bearer ${stringGetter(ACCESS_TOKEN_KEY)}`;
    }
    return addTenantOriginHeader(req);
});

UnauthedAPIHandler.interceptors.request.use(req => {
    return addTenantOriginHeader(req);
});

export { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, APIHandler, UnauthedAPIHandler, EventSourceHandler };
